import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');
const filter = require('lodash/filter');
const map = require('lodash/map');
const keys = require('lodash/keys');
const find = require('lodash/find');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ServerRequest = require('../../actions/request');
const ShortCourseInstanceActions = require('../../actions/ShortCourseInstanceActions');
const ShortCourseInstanceStore = require('../../stores/ShortCourseInstanceStore');
const GroupStore = require('../../stores/GroupStore');
const GroupActions = require('../../actions/GroupActions');

const propTypes = {
    courseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onViewCourseInstance: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    courseName: PropTypes.string,
};
const defaultProps = {
    courseName: 'Course',
};

const paramOptions = {
    [Globals.short_course_instance.param_options.REQUIRED]: Strings['en'].short_course.modals.create_instance.param_options.REQUIRED,
    [Globals.short_course_instance.param_options.OPTIONAL]: Strings['en'].short_course.modals.create_instance.param_options.OPTIONAL,
    [Globals.short_course_instance.param_options.HIDE]: Strings['en'].short_course.modals.create_instance.param_options.HIDE,
};

class LocalCourseInstanceCreateUI extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCreateDialog: true,
            groupId: -1,
            name: props.courseName,
            nameOption: Globals.short_course_instance.param_options.REQUIRED,
            emailOption: Globals.short_course_instance.param_options.OPTIONAL,
            useAccessCodes: true,
            description: '',
            errorText: '',
            errorCode: '',
            resultText: '',
            resultRoute: '',
            groupStoreState: GroupStore.getState(),
            waitingForStudents: false,
            createInstanceActionId: null,
        };

        this.closeCreateDialog = this.closeCreateDialog.bind(this);
        this.createCourseInstanceHandler = this.createCourseInstanceHandler.bind(this);
        this.onSelectGroup = this.onSelectGroup.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.setUseAccessCode = this.setUseAccessCode.bind(this);
        this.setNextNameOption = this.setNextNameOption.bind(this);
        this.setNextEmailOption = this.setNextEmailOption.bind(this);
        this.onViewCreatedCourseInstance = this.onViewCreatedCourseInstance.bind(this);
        this.renderErrorDialog = this.renderErrorDialog.bind(this);
        this.renderWaitDialog = this.renderWaitDialog.bind(this);
        this.renderResultDialog = this.renderResultDialog.bind(this);

        this.unsubscribes = [
            GroupStore.listen(this.onGroupStoreChange.bind(this)),
            ShortCourseInstanceStore.listen(this.onShortCourseInstanceStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        GroupActions.getGroups(uuid.v4());
    }

    componentWillUnmount() {
        if (this.stopMe) {
            clearTimeout(this.stopMe);
        }

        this.unsubscribes.forEach(u => u());
    }

    onGroupStoreChange(state) {
        const groupStudents = this.state.groupStoreState.group_users[this.state.groupId];
        const waitingForStudents = ((this.state.groupId >= 0) && (typeof groupStudents === 'undefined'));
        this.setState({
            groupStoreState: state,
            waitingForStudents: waitingForStudents
        });
    }

    closeCreateDialog() {
        this.props.onClose();
    }

    onShortCourseInstanceStoreChange(state) {
        if (state.action.id === this.state.createInstanceActionId) {
            let updatedState = { createInstanceActionId: null };
            if (!state.action.error) {
                updatedState = {
                    ...updatedState,
                    resultText: 'Course Instance Created',
                    resultRoute: `/course_instance/${state.action.newInstanceHash}`,
                };
            }
            else {
                if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                    console.log(state.action.error);
                }

                updatedState = {
                    ...updatedState,
                    errorText: "Failed to complete course instance setup.",
                }
            }

            this.setState(updatedState);
        }
    }

    createCourseInstanceHandler() {
        const createInstanceActionId = uuid.v4();
        this.setState(
            { createInstanceActionId: createInstanceActionId },
            () => {
                console.log('createCourseInstanceHandler setState callback');
                ShortCourseInstanceActions.createLocalShortCourseInstance(
                    createInstanceActionId,
                    {
                        shortCourseId: this.props.courseId,
                        groupId: (this.state.groupId >= 0) ? this.state.groupId : undefined, // use this for group...
                        name: this.state.name,
                        joinOptions: { // ...OR use this for join links.
                            nameOption: this.state.nameOption,
                            emailOption: this.state.emailOption,
                            useAccessCodes: this.state.useAccessCodes,
                        },
                    }
                );
            }
        );
    }

    onSelectGroup(e) {
        const groupId = parseInt(e.target.value, 10);
        const waitingForStudents = (groupId >= 0 && typeof this.state.groupStoreState.group_users[groupId] === 'undefined');
        this.setState(
            {
                groupId: groupId,
                waitingForStudents: waitingForStudents,
            },
            () => {
                if (waitingForStudents) {
                    GroupActions.getGroupUsers(uuid.v4(), { id: groupId });
                }
            }
        );
    }

    onNameChange(e) {
        this.setState({ name: e.target.value });
    }

    setUseAccessCode(e) {
        this.setState({ useAccessCodes: e.target.checked });
    }

    setNextNameOption() {
        const k = keys(paramOptions);
        let i = k.indexOf(this.state.nameOption);
        i = (i+1) % k.length;
        this.setState({ nameOption: k[i] });
    }

    setNextEmailOption() {
        const k = keys(paramOptions);
        let i = k.indexOf(this.state.emailOption);
        i = (i+1) % k.length;
        this.setState({ emailOption: k[i] });
    }

    onViewCreatedCourseInstance() {
        this.props.onViewCourseInstance(this.state.resultRoute);
    }

    renderErrorDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>{Strings['en'].short_course.modals.create_instance.MODAL_HEADER}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.errorText}
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.closeCreateDialog}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderWaitDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>{Strings['en'].short_course.modals.create_instance.MODAL_HEADER}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {Strings['en'].short_course.modals.create_instance.CREATING_STATUS_TEXT}
                </Modal.Body>
            </Modal>
        );
    }

    renderResultDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>{Strings['en'].short_course.modals.create_instance.MODAL_HEADER}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.resultText}
                    <div className="seperator-thick"/>
                    {(this.state.resultRoute) && <Button onClick={this.onViewCreatedCourseInstance}>View</Button>}
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        if (this.state.errorText) {
            return this.renderErrorDialog();
        }

        if (this.state.createInstanceActionId) {
            return this.renderWaitDialog();
        }

        if (this.state.resultText) {
            return this.renderResultDialog();
        }

        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>{Strings['en'].short_course.modals.create_instance.MODAL_HEADER}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group>
                        <div>
                            <label className="label-form">{Strings['en'].short_course.modals.create_instance.GROUP_DROPDOWN_LABEL}</label>
                            <br/>
                            <select value={this.state.groupId} onChange={this.onSelectGroup}>
                                <option key="none" value={-1}>{Strings['en'].short_course.modals.create_instance.GROUP_ANON_OPTION}</option>
                                {(this.state.groupStoreState && this.state.groupStoreState.groups && this.state.groupStoreState.groups.length > 0) &&
                                    this.state.groupStoreState.groups.map((group) => {
                                        const groupStudents = this.state.groupStoreState.group_users[group.id];
                                        let extra = '';
                                        let disabled = false; // TODO: ever used?
                                        if (groupStudents) {
                                            const activeStudents = groupStudents ? filter(groupStudents, { group_status:'ACTIVE' }) : [];
                                            if (activeStudents.length != 1) {
                                                extra = ` (${activeStudents.length} students)`;
                                            }
                                            else {
                                                extra = ` (${activeStudents.length} student)`;
                                            }
                                        }

                                        return (
                                            <option key={group.id} value={group.id} disabled={disabled}>{group.name + extra}</option>
                                        );
                                    })
                                }
                            </select>
                            <br/>
                        </div>
                        <Form.Label htmlFor="courseWorkTitle">{Strings['en'].short_course.modals.create_instance.INST_NAME_INPUT_LABEL}</Form.Label>
                        <Form.Control id="courseWorkTitle" type='text' value={this.state.name} onChange={this.onNameChange} />
                        {(this.state.groupId < 0) &&
                            <div>
                                <div className="assignment-create-option-line">
                                    <label className="label-form left-label">{Strings['en'].short_course.modals.create_instance.USER_NAME_TOGGLE_LABEL}</label>
                                    <button className="btn-options" onClick={this.setNextNameOption}>{this.state.nameOption}</button>
                                </div>

                                <div className="assignment-create-option-line">
                                    <label className="label-form left-label">{Strings['en'].short_course.modals.create_instance.USER_EMAIL_TOGGLE_LABEL}</label>
                                    <button className="btn-options" onClick={this.setNextEmailOption}>{this.state.emailOption}</button>
                                </div>

                                <div className="assignment-create-option-line">
                                    <input
                                        id="cb-access-code"
                                        type="checkbox"
                                        checked={this.state.useAccessCodes}
                                        onChange={this.setUseAccessCode}
                                    />
                                    <label className="label-form right-label" htmlFor="cb-access-code">{Strings['en'].short_course.modals.create_instance.ACCESS_CODES_TOGGLE_LABEL}</label>
                                </div>
                            </div>
                        }
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        disabled={this.state.waitingForStudents || !!this.state.createInstanceActionId}
                        onClick={this.createCourseInstanceHandler}
                    >
                        {Strings['en'].short_course.modals.create_instance.CREATE_BUTTON_LABEL}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

LocalCourseInstanceCreateUI.propTypes = propTypes;
LocalCourseInstanceCreateUI.defaultProps = defaultProps;

export default LocalCourseInstanceCreateUI;